import {sentry} from '@/config'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
export default {
  install (Vue) {
  //初始化sentry
    Raven
      .config(sentry)
      .addPlugin(RavenVue, Vue)
      .install()
    Vue.config.errorHandler = (err, vm) => {
      Raven.captureMessage(err, {
        level: 'error'
      })
    }
    Object.defineProperty(Vue.prototype, '$log', {
      value: {
        write (title = '', context = '', level = 'info', tags = {}) {
          Raven.captureMessage(title, {level, context, tags})
        },
        writeExLog (ex, context = '', level = 'info', tags = {}) {
          Raven.captureException(ex, {level, tags, extra: { context }})
        }
      },
      writable: false
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/sentry/index.js